<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        :columns="columns"
        :rows="listaEvents"
        title-table="Eventos"
        module="eventSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_CORE_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_CORE_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import { verificarPermissao } from "@/auth/utils";
import FormInsert from "@/views/modules/event/form/EventFormInsert.vue";

export default {
  name: "EventSetting",
  components: {
    BRow,
    BCol,
    TableComponents,
  },
  computed: {
    ...mapState("eventSettingsModule", {
      listaEvents: (state) => state.listaEvents,
    }),
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: "id",
          field: "id",
        },
        {
          label: "Nome",
          field: "nome",
        },
        {
          label: "Tipo Evento",
          field: "tipoEvento.nome",
        },
        {
          label: "Data Inicial",
          field: "dataInicial",
          formatFn: (value) => (value ? value.replace(/-/g, "/") : ""),
        },
        {
          label: "Data Final",
          field: "dataFinal",
          formatFn: (value) => (value ? value.replace(/-/g, "/") : ""),
        },
        {
          label: "Ação",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.$store.dispatch("eventSettingsModule/resetEvent");
      this.$router.push({ name: "evento-add" });
    },
    edit(data) {
      this.$store.dispatch("eventSettingsModule/prepareToEditEvent", data);
      this.$router.push({ name: "evento-edit", params: { id: data.id } });
    },
  },
};
</script>
